import * as React from 'react';
import moment from 'moment-timezone';

import { CheckboxVisibility, ConstrainMode, DetailsList, DetailsRow, IColumn, IDetailsRowProps, Selection } from '@fluentui/react';

import { OnSite } from '../../redux/on-site-manager/on-sites/types';
import { css } from '../../util/Css';

export interface OnSiteDetailsListProps {
  onSiteEventActiveItem: string;
  items: OnSite[];
  columns: IColumn[];
  setOnSiteEventActiveKey: (key: string) => void;
}

export interface OnSiteDetailsListState {
  items?: OnSite[];
}

export class OnSiteDetailsList extends React.Component<OnSiteDetailsListProps, OnSiteDetailsListState> {
  private selection: Selection;

  constructor(props: OnSiteDetailsListProps) {
    super(props);

    this.state = {
      items: [],
    };
    this.selection = new Selection({
      getKey: (data: any) => data.onsiteId,
      canSelectItem: () => true,
    });
  }

  public componentDidMount() {
    this.setItems(this.props.items);
  }

  public componentDidUpdate(prevProps: OnSiteDetailsListProps) {
    if (this.props.items !== prevProps.items) {
      this.setItems(this.props.items);
    }
    if (this.props.onSiteEventActiveItem !== prevProps.onSiteEventActiveItem && this.props.onSiteEventActiveItem) {
      this.selection.setKeySelected(this.props.onSiteEventActiveItem, true, true);
    }
  }

  public render(): JSX.Element {
    const { items } = this.state;

    return (
      <DetailsList
        className="details-list-wrapper"
        compact={true}
        constrainMode={ConstrainMode.horizontalConstrained}
        checkboxVisibility={CheckboxVisibility.hidden}
        items={items as any[]}
        setKey="set"
        columns={this.props.columns}
        selection={this.selection}
        onActiveItemChanged={this.onActiveItemChanged}
        onRenderRow={this.onRenderRow}
      />
    );
  }

  private onRenderRow = (props?: IDetailsRowProps): JSX.Element => {
    const item = props!.item as OnSite;
    const isToday = moment(item.startDateTime).isSame(new Date(), 'days');
    const isPast = moment(item.startDateTime).isBefore(new Date(), 'days');
    const rowClass = css({
      'onsite-today': isToday,
      'onsite-under-utilized': !isPast && item.appointmentsBooked < 0.5 * item.totalAppointments,
      'onsite-utilized': !isPast && item.appointmentsBooked >= 0.9 * item.totalAppointments,
      'onsite-completed-match': isPast && item.appointmentsBooked === item.appointmentsFinished,
      'onsite-completed-mismatch': isPast && item.appointmentsBooked !== item.appointmentsFinished,
    });
    return <DetailsRow className={rowClass} {...props!} />;
  };

  private setItems(items: OnSite[]) {
    this.selection.setItems(items as any);
    this.setState({ items });
  }

  private onActiveItemChanged = (item: OnSite) => {
    this.props.setOnSiteEventActiveKey(item.onsiteId);
  };
}
